import * as APITypes from "~/API";
import { TFunction } from "i18next";

export const INTENTS = {
  _delete_lease: "_delete_lease",
  _terminate_lease: "_terminate_lease",
  _edit_building: "_edit_building",
  _edit_unit: "_edit_unit",
  _edit_property: "_edit_property",
  _add_building: "_add_building",
  _add_parcel: "_add_parcel",
  _edit_parcel: "_edit_parcel",
  _remove_parcel: "_remove_parcel",
  _add_property: "_add_property",
  _add_unit: "_add_unit",
  _signup: "_signup",
  _signin: "_signin",
  _google_signup: "_google_signup",
  _google_signin: "_google_signin",
  _invite_user: "_invite_user",
  _add_service_request: "_add_service_request",
  _edit_service_request: "_edit_service_request",
  _add_comment: "_add_comment",
  _upload_file: "_upload_file",
  _delete_file: "_delete_file",
  _get_upload_url: "_get_upload_url",
  _remove_all_files_for_entity: "_remove_all_files_for_entity",
  _remove_property: "_remove_property",
  _remove_building: "_remove_building",
  _remove_unit: "_remove_unit",
  _remove_service_request: "_remove_service_request",
  _update_request_status: "_update_request_status",
  _refresh: "_refresh",
  _add_lease: "_add_lease",
  _add_tenant: "_add_tenant",
  _advance_lease: "_advance_lease",
  _cancel_lease_actions: "_cancel_lease_actions",
  _rent_paid: "_rent_paid",
  _rent_lost: "_rent_lost",
  _add_amenity: "_add_amenity",
  _add_unit_plan: "_add_unit_plan",
  _edit_unit_plan: "_edit_unit_plan",
  _remove_unit_plan: "_remove_unit_plan",
  _edit_amenity: "_edit_amenity",
  _edit_amenity_availability: "_edit_amenity_availability",
  _remove_amenity: "_remove_amenity",
  _update_renewal_lease: "_update_renewal_lease",
  _initiate_renewal_lease: "_initiate_renewal_lease",
  _normalize_rent_cycle: "_normalize_rent_cycle",
  _add_message: "_add_message",
  _send_chat_message: "_send_chat_message",
  _update_user_profile: "_update_user_profile",
  _close_amenity: "_close_amenity",
  _reopen_amenity: "_reopen_amenity",
  _edit_amenity_reservation_rule: "_edit_amenity_reservation_rule",
  _edit_amenity_reservations_approve: "_edit_amenity_reservations_approve",
  _edit_amenity_reservations_deny: "_edit_amenity_reservations_deny",
  _generate_monthly_finance_report: "_generate_monthly_finance_report",
  _delete_monthly_finance_report: "_delete_monthly_finance_report",
  _delete_yearly_finance_report: "_delete_yearly_finance_report",
  _sumbit_message: "_submit_message",
  _invite_tenant: "_invite_tenant",
  _generate_shadow_invite: "_generate_shadow_invite",
  _generate_property_reports: "_generate_property_reports",
  _edit_lease: "_edit_lease",
  _edit_transactions_approve: "_edit_transactions_approve",
  _edit_transactions_deny: "_edit_transactions_deny",
  _generate_yearly_finance_report: "_generate_yearly_finance_report",
  _terminate_transactions: "_terminate_transactions",
  _request_payment: "_request_payment",
  _bulk_request_rent_payments: "_bulk_request_rent_payments",
  _request_stay_payment: "_request_stay_payment",
  _bulk_request_stay_payments: "_bulk_request_stay_payments",
  _ensure_transaction_receipt: "_ensure_transaction_receipt",
  _save_receipt_signature: "_save_receipt_signature",
  _delete_tenant: "_delete_tenant",
  _create_organization: "_create_organization",
  _request_organization: "_request_organization",
  _edit_organization: "_edit_organization",
  _delete_organization: "_delete_organization",
  _remove_member: "_remove_member",
  _edit_member_details: "_edit_member_details",
  _add_instance_access: "_add_instance_access",
  _edit_instance_access: "_edit_instance_access",
  _remove_instance_access: "_remove_instance_access",
  _toggle_lifecycle_access: "_toggle_lifecycle_access",
  _update_lifecycle_access_status: "_update_lifecycle_access_status",
  _remove_from_organization: "_remove_from_organization",
  _add_stay: "_add_stay",
  _update_stay: "_update_stay",
  _upsert_stay_rate: "_upsert_stay_rate",
  _add_stay_availability: "_add_stay_availability",
  _remove_stay_availability: "_remove_stay_availability",
  _approve_join_request: "_approve_join_request",
  _deny_join_request: "_deny_join_request",
};

export const COLORS = {
  // Red-like colors
  red: "#ff2c2c",
  crimson_red: "#cf1322",
  deep_crimson: "#980000",
  peach: "#ff8550",

  // Green-like colors
  vibrant_green: "#069800",
  pastel_mint: "#7eff79",
  lime_green: "#76c04b",
  forest_green: "#2b9058",
  yellow_green: "#c0ba4b",

  // Orange-like colors
  warm_tangerine: "#fdac4b",
  bright_lemon: "#f1fd4b",

  // Blue-like colors
  light_blue: "#ADD8E6",
  blue: "#0000FF",
  baby_blue: "#4b9bc0",
  turquoise: "#4bc0c0",

  // Grey-like colors
  grey: "#808080",
  whisper_grey: "#F8F8F8",

  // Pink-like colors
  vibrant_pink: "#ff63c6",
  coral_pink: "#ff6384",
};

export const DAYS_OF_WEEK_DB = {
  sunday: "U",
  monday: "M",
  tuesday: "T",
  wednesday: "W",
  thursday: "H",
  friday: "F",
  saturday: "A",
};

export const ENVS = {
  aws_region: process.env.REACT_APP_AWS_REGION || "",
  lambda_api_url: process.env.REACT_APP_LAMBDA_API_URL || "",
  tenant_portal_url: process.env.REACT_APP_TENANT_PORTAL_URL || "",
  freetier_subscription_plan_id:
    process.env.REACT_APP_FREETIER_SUBSCRIPTION_PLAN_ID || "",
  log_enabled: process.env.REACT_APP_LOG_ENABLED || "",
};

export function CALENDAR_MONTHS(t: TFunction<"translation">): string[] {
  return [
    t("January"),
    t("February"),
    t("March"),
    t("April"),
    t("May"),
    t("June"),
    t("July"),
    t("August"),
    t("September"),
    t("October"),
    t("November"),
    t("December"),
  ];
}

export function CALENDAR_OPTIONS(
  t: TFunction<"translation">
): { text: string; value: number }[] {
  return CALENDAR_MONTHS(t).map((text, value) => ({
    text,
    value,
  }));
}

export const SERVICE_REQUEST_TYPES = Array.from(
  new Set<APITypes.ServiceRequestType>([
    APITypes.ServiceRequestType.ApplianceError,
    APITypes.ServiceRequestType.DoorWindow,
    APITypes.ServiceRequestType.Electrical,
    APITypes.ServiceRequestType.ExteriorLawn,
    APITypes.ServiceRequestType.GeneralCleaning,
    APITypes.ServiceRequestType.HeatingCooling,
    APITypes.ServiceRequestType.Other,
    APITypes.ServiceRequestType.PestControl,
    APITypes.ServiceRequestType.Plumbing,
    APITypes.ServiceRequestType.RoofCeiling,
    APITypes.ServiceRequestType.Toilet,
  ])
) as APITypes.ServiceRequestType[];

// TODO: Once organizations are added, Upvoted should be used to provide approval from management
export const SERVICE_REQUEST_STATUS_TYPES: APITypes.ServiceRequestStatusType[] =
  [
    APITypes.ServiceRequestStatusType.Approved,
    APITypes.ServiceRequestStatusType.Canceled,
    APITypes.ServiceRequestStatusType.Rejected,
    APITypes.ServiceRequestStatusType.Running,
    APITypes.ServiceRequestStatusType.Upvoted,
  ];

export const UNIT_STATUS_TYPES: APITypes.UnitStatusType[] = [
  APITypes.UnitStatusType.None,
  // APITypes.UnitStatusType.Occupied,
  APITypes.UnitStatusType.Renovation,
  APITypes.UnitStatusType.Vacant,
];
